<template>
  <div class="crumbs-wrap" :style="{'height': height || '0.89rem', 'line-height': height || '0.89rem'}">
    <a @click="crumbClick(item)" v-for="(item, index) in router.slice(0, router.length - 1)" :key="index">{{item.name}}<span class="separator">{{separator || '>'}}</span></a>
    <template v-if="router.length">
      <span>{{router[router.length - 1].name}}</span>
    </template>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        router: []
      }
    },
    created () {
      this.router = this.routes
    },
    watch: {
      routes () {
        this.router = this.routes
        window.setTimeout(() => {
          this.$el.scrollLeft = this.$el.scrollWidth - this.$el.style.width
        })
      }
    },
    methods: {
      crumbClick (item) {
        this.router.some((value, index, array) => {
          if (value.id === item.id) {
            array.splice(index + 1)
            return true
          }
          return false
        })
        if (typeof this.crumbTrigger === 'function') {
          this.crumbTrigger(item)
        }
        if (item.path) {
          this.$router.push(item.path)
        }
      }
    },
    props: ['routes', 'crumbTrigger', 'height', 'separator']
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.crumbs-wrap{
  &::-webkit-scrollbar{
    width:0px;
    opacity:0;
    -webkit-overflow-scrolling: touch;
  }
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  letter-spacing: 0;
  padding: 0 1.2rem 0 0.3rem;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  a{
    display: inline-block;
    cursor: pointer;
    white-space: nowrap;
    &:last-child{
      color: #999999;
    }
    &:not(:last-child){
      color: #E4393C !important;
     }
    .separator{
      padding: 0 0.18rem;
    }
  }
  >span{
    white-space: nowrap;
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/crumbs.vue